import Vue from 'vue';
import VueRouter from 'vue-router';
import Navigation from '../views/Navigation.vue';
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
import { getAuth } from 'firebase/auth';
import ErrorPage from '../views/auth/NotFound.vue';
import Contact from '../newUI/contact/TheContact.vue';
import Pricing from '../newUI/contact/pricing.vue';
import AccountSummary from '../newUI/subscription/AccountSummary.vue';
import SelectedPlan from '../newUI/useraccount/SelectedPlan.vue';
import PaymentDetails from '../newUI/subscription/PaymentDetails.vue';
import ReviewPurchase from '../newUI/subscription/ReviewPurchase.vue';
import SubscriptionPlan from '../newUI/subscription/SubscriptionPlan.vue';
import CookiesPolicyandTerms from '../newUI/cookiespolicy/Cpt.vue';
import Requests from '../components/Request/Requests.vue';

import UserProfile from '../newUI/useraccount/Profile.vue';
import ForgetPassword from '../newUI/forgetpwd/ForgetPassword.vue';
import AuthPricing from '../newUI/contact/authPricing.vue';
Vue.use(VueRouter);

//Component loading is implemented based on  lazy loading  asynchronously
const ReportViewer = () => import('../views/ReportViewer.vue');
const Terminal = () => import('../views/Terminal.vue');
const Register = () => import('../views/Register.vue');
const LinkAction = () => import('../views/LinkAction.vue');

const PrivacyPolicy = () => import('../views/PrivacyPolicy.vue');
const CookiesPolicy = () => import('../views/CookiesPolicy.vue');

const TermsConditions = () => import('../views/TermsConditions.vue');
const ReleaseNotes = () => import('../views/ReleaseNotes.vue');

const AddOns = () => import('../newUI/addons/HomePage.vue');

const UserFeedbackContactForm = () =>
  import('../components/contact/userFeedbackContactForm.vue');

const routes = [
	{
		path: '/',
		name:'home',
		redirect:'/home',
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/navigation/:selection*',
		name: 'Navigation',
		component: Navigation,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/add-ons',
		name: 'AddOns',
		component: AddOns,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/accountsummary',
		name: 'AccountSummary',
		component: AccountSummary,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/termsandconditions',
		name: 'CookiesPolicyandTerms',
		component: CookiesPolicyandTerms,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/paymentdetails',
		name: 'PaymentDetails',
		component: PaymentDetails,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/subscribe',
		name: 'SubscriptionPlan',
		component: SubscriptionPlan,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/reviewpurchase',
		name: 'ReviewPurchase',
		component: ReviewPurchase,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/choosenplan',
		name: 'SelectedPlan',
		component: SelectedPlan,
		meta: {
			guest: true,
		},
	},
	{
		path: '/userprofile',
		name: 'UserProfile',
		component: UserProfile,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/pricing',
		name: 'pricing',
		component: Pricing,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/pricing/details',
		name: 'pricingSchema',
		component: AuthPricing,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/contact',
		name: Contact,
		component: Contact,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/reportViewer/:clusterId/:projectId/report/:reportId',
		name: 'ReportViewer',
		component: ReportViewer,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/reportViewer/:projectId?',
		name: 'ReportViewerDefault',
		component: ReportViewer,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/terminal',
		name: 'Terminal',
		component: Terminal,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/feedback',
		name: 'UserFeedbackContactForm',
		component: UserFeedbackContactForm,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/requests',
		name: 'Requests',
		component: Requests,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/home',
		name: 'home',
		component: Home,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/privacy-policy',
		name: 'privacy-policy',
		component: PrivacyPolicy,
		meta: {
			guest: true,
		},
	},
	{
		path: '/cookies-policy',
		name: 'cookies-policy',
		component: CookiesPolicy,
		meta: {
			guest: true,
		},
	},
	{
		path: '/terms-conditions',
		name: 'terms-conditions',
		component: TermsConditions,
		meta: {
			guest: true,
		},
	},
	{
		path: '/release-notes',
		name: 'release-notes',
		component: ReleaseNotes,
		meta: {
			guest: true,
		},
	},
	{
		path: '/register/:subscription?',
		name: 'register',
		component: Register,
		meta: {
			guest: true,
		},
	},
	{
		path: '/action',
		name: 'action',
		component: LinkAction,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/forgotPassw',
		name: 'forgotPassw',
		component: ForgetPassword,
		meta: {
			requiresGuest: true,
		},
	},
	{
		path: '/:errorpage(.*)',
		name: 'errorpage',
		component: ErrorPage,
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, _, next) => {
  const auth = getAuth();

  if (to.matched.some((record) => record.meta.requiresAuth) && !auth.currentUser) {
    // If we have a previous redirection to login, we cleanup the url to avoid double redirect
    if (to.query.redirect){
      return next({
        path: to.path
      })
    }else{
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else if (to.matched.some((record) => record.meta.requiresGuest) && auth.currentUser) {
    // If we have a previous redirection, we cleanup the url to avoid double redirect
    if (to.query.redirect){
      return next({
        path: to.path
      })
    } else {
      next({
        path: '/navigation',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  next();
});

export default router;
